import React, { Component } from 'react'
import { ThumbnailContainer } from '.'
import PropTypes from 'prop-types'
import { InfiniteLoader, List, CellMeasurer, CellMeasurerCache, AutoSizer } from 'react-virtualized'
import './thumbnailList.css'
import { withTranslation } from 'react-i18next'
import Header from "../Aside/Header"
import { debounce } from 'lodash'
import CircularProgress from 'material-ui/CircularProgress'

class ThumbnailList extends Component {

    static propTypes = {
        mediaList: PropTypes.object.isRequired,
        currentPosition: PropTypes.number,
        batchSize: PropTypes.number.isRequired,
        threshold: PropTypes.number.isRequired,
        debounceWait: PropTypes.number.isRequired,
        close: PropTypes.func.isRequired,
        isFetchedMedia: PropTypes.func.isRequired,
        groupTitle: PropTypes.string,
        t: PropTypes.func.isRequired,
    }

    constructor(props, context)
    {
        super(props, context);

        this.cache = new CellMeasurerCache({
            fixedWidth: true,
            minHeight: 191,
        })

        this.list = null
        this.listWrapper = null
        this.header = null
        this.rowRenderer = this.rowRenderer.bind(this)
    }

    componentWillReceiveProps()
    {
        this.list.forceUpdateGrid()
    }

    rowRenderer({index, key, parent, style})
    {
        return (
            <CellMeasurer
                cache={ this.cache }
                columnIndex={ 0 }
                key={ key }
                rowIndex={ index }
                parent={ parent }>
                {() => {
                    return <div key={ key } style={ style }>
                        {
                            this.props.mediaList[index] ?
                                <ThumbnailContainer
                                    key={ key }
                                    position={ Number(index) }
                                    thumbnail={ this.props.mediaList[index].location.thumb }
                                    title={ this.props.mediaList[index].title }
                                    selected={ this.props.currentPosition === Number(index) }
                                />
                                :
                                <CircularProgress mode="indeterminate" size={ 40 } thickness={ 5 }/>
                        }
                    </div>
                }}
            </CellMeasurer>
        )
    }

    listHeight() {
        if(! this.listWrapper || ! this.header)
        {
            return 0
        }

        return this.listWrapper.offsetHeight - this.header.height()
    }

    render() {
        const { isFetchedMedia, fetchMedia, count, batchSize, close, threshold, debounceWait, groupTitle, currentPosition, t } = this.props

        return (
            <div className='thumbnails'>
                <Header
                    className='thumbnails-header'
                    close={close}
                    title={t('visualizer:toolbar.left.thumbnail.title')}
                    additionnalTitle={groupTitle}
                    ref={header=> { this.header = header}}
                />

                <div className='thumbnails-list' ref={listWrapper => { this.listWrapper = listWrapper }}>
                    <InfiniteLoader
                        isRowLoaded={isFetchedMedia}
                        loadMoreRows={debounce(fetchMedia, debounceWait)}
                        rowCount={count}
                        minimumBatchSize={batchSize}
                        threshold={threshold}
                    >
                        {({ onRowsRendered, registerChild }) => (
                            <AutoSizer>
                            {() => (
                                <List
                                    className='thumbnail-list-component'
                                    width={250}
                                    onRowsRendered={onRowsRendered}
                                    ref={registerChild => { this.list = registerChild }}
                                    rowCount={count}
                                    rowRenderer={this.rowRenderer}
                                    scrollToIndex={currentPosition}
                                    height={this.listHeight()}
                                    rowHeight={this.cache.rowHeight}
                                />
                            )}
                            </AutoSizer>
                        )}
                    </InfiniteLoader>
                </div>
            </div>
        )
    }
}

export default withTranslation()(ThumbnailList)
